import { render, staticRenderFns } from "./path-breadcrumb.vue?vue&type=template&id=31d470ce"
import script from "./path-breadcrumb.vue?vue&type=script&lang=js"
export * from "./path-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports